import React, { forwardRef, useState, useImperativeHandle, useRef } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

const ConfirmationModal = forwardRef((_, ref) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)
  const [data, setData] = useState({title: '', description: '', successButton: '', rejectButton: ''})

  const promissesRef = useRef({resolve: null, reject: null})

  useImperativeHandle(ref, () => ({
    show: async ({title, description, successButton = t('Delete'), rejectButton = t('Cancel')}) => {
      return new Promise((resolve, reject) => {
        promissesRef.current = {resolve, reject}
        setData({title, description, successButton, rejectButton})
        setOpen(true)
      })
    }
  }))

  const handleClose = (success) => {
    if (promissesRef.current.resolve) {
      promissesRef.current.resolve({success})
    }
    setOpen(false)
  }

  return (
    <Dialog onClose={() => handleClose(false)} maxWidth={'sm'} open={open}>
      <div className={styles.container}>
        <div>
          <div className={styles.title}>{ data.title }</div>
          <div className={styles.description}>{ data.description }</div>
        </div>
        <div className={styles.actions}>
          <div className={styles.reject} onClick={() => handleClose(false)}>
            { data.rejectButton }
          </div>
          <div className={styles.success} onClick={() => handleClose(true)}>
            { data.successButton }
          </div>
        </div>
      </div>
    </Dialog>
  )
})

export default ConfirmationModal
